import React from 'react';
import styled from 'styled-components';
import {LOCHMARA, LOCHMARA_SHADOW} from '../refs/Colors';
import {Icon} from './Icon';
import {ICON_ARROW_DOWN, ICON_ARROW_UP} from '../refs/Icons';
import {getColor} from '../utils/styled';
import {Toggleable} from "@/types/Toggleable.ts";

type TriggerPopupSmallProps = {
  className?: string;
  toggleable: Toggleable,
  children: string;
  icon?: string;
};

// Figma tokens
const BG_HOVER = '#dfedf4';
const BG_ACTIVE_OPEN = '#cce6f3';

const Wrapper = styled.div<{ $isOpen?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  position: relative;
  border-radius: 5px;
  padding: 2px 0 2px 5px;
  background-color: ${(p) => (p.$isOpen ? BG_ACTIVE_OPEN : 'transparent')};

  &:hover {
    background-color: ${BG_HOVER};
  }

  &:active {
    background-color: ${BG_ACTIVE_OPEN};
  }
`;


const Label = styled.span`
  cursor: pointer;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 1;
  color: ${getColor(LOCHMARA_SHADOW)};
`;

export const TriggerPopupSmall: React.FC<TriggerPopupSmallProps> = ({
  className,
  children,
  icon,
  toggleable,
}) => {
  return (
    <Wrapper className={className} $isOpen={toggleable.isOpen} onClick={toggleable.toggle}>
      {icon && <Icon color={LOCHMARA_SHADOW} size={24} fontSize={18} icon={icon} />}
      <Label>{children}</Label>
      <Icon color={LOCHMARA} size={18} fontSize={10} icon={toggleable.isOpen ? ICON_ARROW_UP : ICON_ARROW_DOWN} />
    </Wrapper>
  );
};

export default TriggerPopupSmall;
